import { CreateEmptyFirestoreDocParams } from '@usacsmideo/types';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../constants/firebaseModular';

export const createEmptyFirestoreDoc = async (payload: CreateEmptyFirestoreDocParams) => {
  let data = {};
  const docRef = doc(db, 'users', payload.patientId, 'Chart', payload.title);
  if (payload.title === 'PATIENT_SIGNATURE') {
    data = {
      signature1DataURI: '',
    };
  }
  // THE SAME EMPTY SHAPE THE BACKEND'S createChart WRITES (getEmptySelectedTreatmentOption). ATTESTATION CLEARS
  // THIS DOC TO RE-TRIGGER ITS INIT. CHART DOCS ARE NEVER DELETED; THE RULES REFUSE IT (CU-17tm466r238).
  if (payload.title === 'SELECTED_TREATMENT_OPTION') {
    data = {
      description: '',
    };
  }
  if (payload.title === 'WITNESS_SIGNATURE') {
    data = {
      signature1DataURI: '',
      witnessName: '',
      witnessEmail: '',
      signature2DataURI: '',
      witness2Name: '',
      witness2Email: '',
    };
  }
  return await setDoc(docRef, data);
};
